import React from 'react';
import { Form } from './Form';

import './Form.css';


export const FormRegister = () => {
  return (
    <div id="formRegisterContainer">
      <Form />
    </div>
  );
};
